import { imageMaxBytes } from "widgets/social2/utils";

export const MAX_IMAGE_BYTES = imageMaxBytes();
